import { all } from "redux-saga/effects";
import { saga as streamSaga } from "../ducks/stream";
import { saga as eventSaga } from "../ducks/event";
import { saga as imageSaga } from "../ducks/image";

export default function*() {
  yield all([streamSaga(), eventSaga(), imageSaga()]);
}
